// extracted by mini-css-extract-plugin
export default {"header":"NoelSolidaireHeader_header__UH1G2","visual":"NoelSolidaireHeader_visual__y8sT2"};